import { render, staticRenderFns } from "./ShadowWebsocketView.vue?vue&type=template&id=511aa0d8&scoped=true"
import script from "./ShadowWebsocketView.vue?vue&type=script&lang=js"
export * from "./ShadowWebsocketView.vue?vue&type=script&lang=js"
import style0 from "./ShadowWebsocketView.vue?vue&type=style&index=0&id=511aa0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511aa0d8",
  null
  
)

export default component.exports